<script setup>
import { passwordValidator } from "@/@core/utils/validators"
import { useContractorAuthStore } from "@/composables/store/contractor/useAuthStore"
import { useSuccessStore } from "@/composables/store/useSuccessStore"
import { useGenerateImageVariant } from "@core/composable/useGenerateImageVariant"
import Logo from '@images/illustrations/sphiere_logo.png'
import authV2ForgotPasswordIllustrationDark from "@images/pages/auth-v2-forgot-password-illustration-dark.png"
import authV2ForgotPasswordIllustrationLight from "@images/pages/auth-v2-forgot-password-illustration-light.png"
import authV2MaskDark from "@images/pages/misc-mask-dark.png"
import authV2MaskLight from "@images/pages/misc-mask-light.png"

const route = useRoute()
const authStore = useContractorAuthStore()
const successStore = useSuccessStore()
const router = useRouter()

const email = ref(route.query.email || "")
const token = ref(route.query.token || "")
const password = ref("")
const confirmPassword = ref("") // Add confirm password ref
const refVForm = ref(null)

const authThemeImg = useGenerateImageVariant(
    authV2ForgotPasswordIllustrationLight,
    authV2ForgotPasswordIllustrationDark
)

const authThemeMask = useGenerateImageVariant(authV2MaskLight, authV2MaskDark)

// Add password match validator
const passwordMatchValidator = (value) => {
    if (value !== password.value) {
        return "Passwords do not match"
    }
    return true
}

definePage({
    meta: {
        layout: "blank",
        unauthenticatedOnly: true,
    },
});

const init = async () => {
    //   if (!token.value && !email.value) {
    //     router.push({ name: "login" });
    //   }
};

const onSubmit = async () => {
    try {
        const isValid = await refVForm.value.validate()
        if (!isValid.valid) return

        const response = await authStore.resetPassword({
            email: email.value,
            token: token.value,
            password: password.value,
            password_confirmation: confirmPassword.value // Use confirmPassword here
        })

        if (response) {
            successStore.setSuccessMessage("Password reset successfully")
            router.push({ name: 'contractor-authentication-login' })
        }
    } catch (error) {
        console.error("Reset error:", error.response?.data?.message || error.message)
        // Show error to user
    }
};

init();
</script>

<template>
    <VRow class="auth-wrapper bg-surface" no-gutters>
        <VCol md="7" class="d-none d-md-flex" style="
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        margin: 0;
        background:#232323;
        block-size: 100vh;
        color: white;
      ">

            <div class="d-flex align-center justify-center w-100 h-100">
                <VImg :src="Logo" style="max-block-size: 200px; max-inline-size: 300px;" />
            </div>

        </VCol>

        <VCol cols="12" md="5" class="auth-card-v2 d-flex align-center justify-center">
            <VCard flat :max-width="500" class="mt-12 mt-sm-0 pa-4">
                <VCardText>
                    <h4 class="text-h4 mb-1">Reset Password?</h4>
                    <p class="mb-0">
                        Enter your new password below to reset your password.
                    </p>
                </VCardText>

                <VCardText>
                    <VForm ref="refVForm" @submit.prevent="onSubmit">
                        <VRow>
                            <!-- email -->
                            <VCol cols="12">
                                <AppTextField v-model="email" autofocus disabled label="Email" type="email" />
                            </VCol>

                            <!-- New Password -->
                            <VCol cols="12">
                                <AppTextField v-model="password" :rules="[requiredValidator, passwordValidator]"
                                    label="New Password" type="password" />
                            </VCol>

                            <!-- Confirm Password -->
                            <VCol cols="12">
                                <AppTextField v-model="confirmPassword"
                                    :rules="[requiredValidator, passwordMatchValidator]" label="Confirm New Password"
                                    type="password" />
                            </VCol>

                            <!-- Reset button -->
                            <VCol cols="12">
                                <VBtn :loading="authStore.isResetPasswordLoading" block type="submit">
                                    Reset Password
                                </VBtn>
                            </VCol>

                            <!-- back to login -->
                            <VCol cols="12">
                                <RouterLink class="d-flex align-center justify-center"
                                    :to="{ name: 'contractor-authentication-login' }">
                                    <VIcon icon="tabler-chevron-left" class="flip-in-rtl" />
                                    <span>Back to login</span>
                                </RouterLink>
                            </VCol>
                        </VRow>
                    </VForm>
                </VCardText>
            </VCard>
        </VCol>
    </VRow>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth.scss";
</style>
